import React from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { RightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { loadHotTokens } from '@/actions/tokens'

const HotSearchWrapper = styled.div`
  margin-bottom: 30px;
`
const FlexDisplay = styled.div`
  display: flex;
  margin-left: 10px;
  align-items: center;
`
const ItemWrapper = styled.div`
  display: flex;
  margin-left: 16px;
  align-items: center;
  cursor: pointer;
`
const Text = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  color: ${({ theme }) => theme.colors.white};
  padding-left: 5px;
  &:hover {
    color: ${({ theme }) => theme.colors_v2.primary_yellow};
  }
`
const SText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  padding-left: 15px;
`
const Title = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xxs};
  white-space: nowrap;
  margin-left: 10px;
`
const TokenIcon = styled.img`
  width: 18px;
  height: 18px;
  border-radius: 50%;
`

class HotSeach extends React.Component {
  constructor(props) {
    super(props)
    this.state = { width: 0 }
  }

  updateDimensions = () => {
    this.setState({ width: document.body.clientWidth })
  }

  componentDidMount() {
    this.props.loadHotTokens()
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  mapTokenRecordType = (type) => {
    switch (type) {
      case 'WRC10':
        return 'token10'
      case 'WRC20':
        return 'token20'
      case 'WRC721':
        return 'token721'
      default:
        return 'token'
    }
  }

  renderItem = (item, i) => {
    return (
      <Col key={`${item._id}-${i}`}>
        <FlexDisplay>
          <TokenIcon
            src={item.token_icon ? item.token_icon : '/token-record-default.jpg'}
            onError={(e) => (e.target.src = '/token-record-default.jpg')}
          />
          <Link to={`/${this.mapTokenRecordType(item.token_record_type)}/${item._id}`}>
            <Text>{item.token_abbreviation}</Text>
          </Link>
        </FlexDisplay>
      </Col>
    )
  }
  render() {
    const numberItem = Math.round(this.state.width / 160) - 1

    return (
      <HotSearchWrapper id="hotsearch">
        <Row align="middle">
          <Col>
            <Title>Hot Search:</Title>
          </Col>
          {this.props.hotTokens?.slice(0, numberItem)?.map((item, i) => this.renderItem(item, i))}
          <Col>
            <Link to="/searchmore">
              <ItemWrapper>
                <SText>more</SText> <RightOutlined style={{ fontSize: '8px', marginLeft: '2px' }} />
              </ItemWrapper>
            </Link>
          </Col>
        </Row>
      </HotSearchWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    hotTokens: state.hotTokensReducer.hotTokens,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    loadHotTokens: () => {
      dispatch(loadHotTokens())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(HotSeach)
